import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

type SupabaseClientInstance = ReturnType<typeof createClient>;

let supabaseInstance: SupabaseClientInstance | null = null;
let publicInstance: SupabaseClientInstance | null = null;

/**
 * Verifica se as credenciais do backend estão configuradas.
 */
export function isSupabaseConfigured(): boolean {
  return Boolean(supabaseUrl && supabaseAnonKey);
}

/**
 * Client com autenticação (login / sessão persistida).
 * Use SOMENTE no painel administrativo, onde o login é necessário.
 */
export function getSupabase(): SupabaseClientInstance {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return supabaseInstance;
}

/**
 * Client somente leitura para conteúdo público (blog, pop-ups, etc).
 * Não persiste nem renova sessão, portanto NUNCA dispara chamadas de
 * autenticação em segundo plano nas páginas abertas ao visitante.
 * Isso evita erros do tipo "Failed to fetch" no token de refresh.
 */
export function getPublicSupabase(): SupabaseClientInstance {
  if (!publicInstance) {
    publicInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    });
  }
  return publicInstance;
}